import React from 'react';
import TableFooter from '../EstimatedOOHBudgetTable/components/Footer/Footer';
import useFooterData from '../EstimatedOOHBudgetTable/hooks/useFooterData';
import { Countries } from '../../../../../../../../../shared/enums';
import { OOHRow } from '../../../../../../../../../api/services/mediaPlanning/offline/oohBudget';
import { Currencies } from '../../../../../../../../../shared/types';

interface TVOptionalFooterProps {
  rows: OOHRow[];
  currency?: Currencies;
  country?: Countries;
}

export default function TVOptionalFooter({
  rows,
  currency = 'PLN',
  country = Countries.POLAND,
}: TVOptionalFooterProps) {
  const footerData = useFooterData({
    rows,
    optionalIds: {},
    currency,
    country,
  });

  return <TableFooter data={footerData} currency="PLN" freeColumns={1} />;
}
